import defaultStates, { defaultLifeCycle } from '@/constants/lifecycle';

const userActions = {
  APPLY_COMMONS_MODE: 'APPLY_COMMONS_MODE',
  APPLY_CURRENT_USER: 'APPLY_CURRENT_USER',
  APPLY_GUEST_USER: 'APPLY_GUEST_USER',
  APPLY_PERMISSIONS: 'APPLY_PERMISSIONS',
  APPLY_ROLE: 'APPLY_ROLE',
  APPLY_ROLE_ACTIONS: 'APPLY_ROLE_ACTIONS',
  APPLY_USER_GROUPS: 'APPLY_USER_GROUPS',
  ARCHIVE_USERS: 'ARCHIVE_USERS',
  ARCHIVE_USERS_ERROR: 'ARCHIVE_USERS_ERROR',
  ARCHIVE_USERS_SUCCESS: 'ARCHIVE_USERS_SUCCESS',
  CLOSE_USER: 'CLOSE_USER',
  CLOSE_USERS: 'CLOSE_USERS',
  FETCH_GUEST_USER: 'FETCH_GUEST_USER',
  FETCH_GUEST_USER_ERROR: 'FETCH_GUEST_USER_ERROR',
  FETCH_ROLE_ACTIONS: 'FETCH_ROLE_ACTIONS',
  FETCH_USER: 'FETCH_USER',
  FETCH_USER_ERROR: 'FETCH_USER_ERROR',
  FETCH_USERS: 'FETCH_USERS',
  FETCH_FILTERED_USERS: 'FETCH_FILTERED_USERS',
  HIDE_ARCHIVE_USER: 'HIDE_ARCHIVE_USER',
  REFRESH_USERS: 'REFRESH_USERS',
  REFRESH_USERS_METRICS: 'REFRESH_USERS_METRICS',
  RESTORE_USERS: 'RESTORE_USERS',
  ROLE_CHANGED: 'ROLE_CHANGED',
  ROLE_UPDATED: 'ROLE_UPDATED',
  SHOW_ARCHIVE_USER: 'SHOW_ARCHIVE_USER',
  SHOW_ARCHIVE_USERS: 'SHOW_ARCHIVE_USERS',
  SHOW_USER: 'SHOW_USER',
  SHOW_USER_ERROR: 'SHOW_USER_ERROR',
  SHOW_USERS: 'SHOW_USERS',
  SHOW_USERS_ERROR: 'SHOW_USERS_ERROR',
  SHOW_USERS_METRICS: 'SHOW_USERS_METRICS',
  SHOW_USERS_METRICS_ERROR: 'SHOW_USERS_METRICS_ERROR',
  TOGGLE_MY_APPROVAL: 'TOGGLE_MY_APPROVAL',
  TOGGLE_MY_ARCHIVED: 'TOGGLE_MY_ARCHIVED',
  TOGGLE_USER_SELECTED: 'TOGGLE_USER_SELECTED',
  TOGGLE_USERS_COLUMN_ORDER_BY: 'TOGGLE_USERS_COLUMN_ORDER_BY',
  TOGGLE_USERS_PRESENTATION: 'TOGGLE_USERS_PRESENTATION',
  TOGGLE_USERS_SELECTED: 'TOGGLE_USERS_SELECTED',
  TOGGLE_USERS_SINGLE_SORTING: 'TOGGLE_USERS_SINGLE_SORTING',
  UPDATE_USER_APPROVED: 'UPDATE_USER_APPROVED',
  UPDATE_USER_APPROVED_ERROR: 'UPDATE_USER_APPROVED_ERROR',
  UPDATE_USER_APPROVED_SUCCESS: 'UPDATE_USER_APPROVED_SUCCESS',
  UPDATE_USER_PANELS: 'UPDATE_USER_PANELS',
  UPDATE_USER_SEARCHABLE: 'UPDATE_USER_SEARCHABLE',
  UPDATE_USER_SEARCHABLE_ERROR: 'UPDATE_USER_SEARCHABLE_ERROR',
  UPDATE_USER_SEARCHABLE_SUCCESS: 'UPDATE_USER_SEARCHABLE_SUCCESS',
  UPDATE_USERS_FILTER: 'UPDATE_USERS_FILTER',
  UPDATE_USERS_FLAGS: 'UPDATE_USERS_FLAGS',
  UPDATE_USERS_ROLE_FILTER: 'UPDATE_USERS_ROLE_FILTER',
};

export const userState = {
  APPROVED: 'approved',
  UNAPPROVED: 'unapproved',
  ARCHIVED: 'archived',
};

export const userSearchableIcon = (searchable) => (searchable ? 'search minus' : 'search plus');

const userIcons = {
  archived: { icon: 'user outline', color: 'error' },
  approved: { icon: 'user', color: 'approved' },
  unapproved: { icon: 'user outline', color: 'warning' },
};

export const userIcon = ({ archived, approved }) => {
  let icon = archived ? 'archived' : 'unapproved';
  if (!archived && approved) { icon = 'approved'; }
  return { ...userIcons[icon], message: `status.${icon}`, verbose: `status.${icon}.verbose` };
};

export const userLists = ['all'];

export const userCategories = [...userLists, 'open'];

export const userLifeCycle = [...defaultLifeCycle];

export const userStates = {
  ...defaultStates,
};

export const userTabs = {
  GROUPS: { name: 'groups', icon: 'users' },
};

export default userActions;
